export const MailIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.632" viewBox="0 0 16 12.632">
      <path id="mail_24dp_E8EAED_FILL1_wght300_GRAD0_opsz24" d="M101.522-767.368a1.469,1.469,0,0,1-1.08-.442,1.47,1.47,0,0,1-.442-1.08v-9.587a1.469,1.469,0,0,1,.442-1.08,1.469,1.469,0,0,1,1.08-.442h12.955a1.469,1.469,0,0,1,1.08.442,1.469,1.469,0,0,1,.442,1.08v9.587a1.469,1.469,0,0,1-.442,1.08,1.469,1.469,0,0,1-1.08.442ZM108-773.214l6.737-4.308-.129-1.214L108-774.526l-6.607-4.211-.129,1.214Z" transform="translate(-100 780)" fill="#22638d" />
    </svg>
  )
}